import './index.css'

const Filters = props => {
  const {sal, emp, typeSalChange, typeEmpChange} = props

  const empt = event => {
    typeEmpChange(event.target.id)
    console.log(event.target.id)
  }

  const salt = event => {
    typeSalChange(event.target.id)
    console.log(event.target.id)
  }

  return (
    <div className="fildiv">
      <h1>Type of Employment</h1>
      <ul className="litem">
        {emp.map(e => (
          <li className="mm" onChange={empt} key={e.employmentTypeId}>
            <input id={e.employmentTypeId} type="checkbox" />
            <label htmlFor={e.employmentTypeId}>{e.label}</label>
          </li>
        ))}
      </ul>

      <hr />
      <h1>Salary Range</h1>
      <ul>
        {sal.map(e => (
          <li className="mm" onChange={salt} key={e.salaryRangeId}>
            <input id={e.salaryRangeId} name="salary" type="radio" />
            <label htmlFor={e.salaryRangeId}>{e.label}</label>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Filters
